import { render, staticRenderFns } from "./experts-plan-card.vue?vue&type=template&id=a3903dac"
import script from "./experts-plan-card.vue?vue&type=script&lang=js"
export * from "./experts-plan-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports